(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('breadcrumbs-scroller')) {
    customElements.define('breadcrumbs-scroller', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          if (this.scrollWidth > this.clientWidth) {
            this.scrollLeft = this.scrollWidth;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-money-format-javascript"] && !Shopify.designMode) return;
  try {
    window.customMoneyFormat = function(cents) {
  var config = window.customMoneyFormatConfig;

  if (!config || !config.enabled || !config.format) {
    return null;
  }

  function formatWithDelimiters(number, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(2);
    var parts = number.split('.');
    var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return integer + decimal + parts[1];
  }

  var n = cents;
  switch (config.format) {
    case '{amount_with_space_separator} kr': return formatWithDelimiters(n, '\u00a0', ',') + '\u00a0kr';
    case '{amount_with_space_separator} €':  return formatWithDelimiters(n, '\u00a0', ',') + '\u00a0€';
    case '{amount_no_separator} €':          return formatWithDelimiters(n, '', ',') + '\u00a0€';
    case '{amount_no_separator} zł':         return formatWithDelimiters(n, '', ',') + '\u00a0zł';
    case '€ {amount_with_dot_separator}':    return '€\u00a0' + formatWithDelimiters(n, '.', ',');
    case '{amount_with_dot_separator} €':    return formatWithDelimiters(n, '.', ',') + '\u00a0€';
    default:                                 return null;
  }
};
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkl__custom-discount"] && !Shopify.designMode) return;
  try {
    class DklCustomPickerRadioGroups extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    // Remove stale quantity listeners before re-querying
    if (this.quantityInput && this._qtyHandler) {
      this.quantityInput.removeEventListener('change', this._qtyHandler);
      this.quantityInput.removeEventListener('input', this._qtyHandler);
    }

    this.options = this.querySelectorAll('.dkl-custom-picker__option');
    this.radios = this.querySelectorAll('.dkl-custom-picker__radio');
    this.tierValues = this.getTierValues();
    this.updatingFromRadio = false;
    this.updatingFromQty = false;

    const productArea = this.closest('.product-area, .product-detail, [data-product-blocks], .product-info, .product__blocks, .product-single');
    const section = productArea || this.closest('section') || this.parentElement;
    this.quantityInput = section.querySelector('quantity-wrapper [name="quantity"]')
      || section.querySelector('[name="quantity"]');

    // Radio → quantity sync
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.handleRadioChange(radio));
    });

    // Prevent clicks on disabled options
    this.options.forEach((option) => {
      option.addEventListener('click', (e) => {
        if (option.classList.contains('is-disabled')) {
          e.preventDefault();
        }
      });
    });

    // Quantity → radio sync
    if (this.quantityInput) {
      this._qtyHandler = () => this.handleQtyChange();
      this.quantityInput.addEventListener('change', this._qtyHandler);
      this.quantityInput.addEventListener('input', this._qtyHandler);
    }

    // Sync picker selection to current quantity input value
    this.handleQtyChange();
  }

  /** Build sorted array of tier qty values from the radios */
  getTierValues() {
    const values = [];
    this.radios.forEach((radio) => {
      if (radio.value === 'default') {
        values.push({ qty: 1, radio });
      } else {
        values.push({ qty: parseInt(radio.value, 10), radio });
      }
    });
    // Sort ascending by qty so we can match thresholds
    values.sort((a, b) => a.qty - b.qty);
    return values;
  }

  /** User clicked a custom tier radio */
  handleRadioChange(radio) {
    if (this.updatingFromQty) return;
    this.updatingFromRadio = true;

    // Update visual selected state
    this.options.forEach((opt) => opt.classList.remove('is-selected'));
    radio.closest('.dkl-custom-picker__option').classList.add('is-selected');

    // Sync the quantity input to match the tier
    if (this.quantityInput) {
      const qty = radio.value === 'default' ? 1 : parseInt(radio.value, 10);
      this.quantityInput.value = qty;
      // Dispatch change so Symmetry's QuantityWrapper and any other
      // listeners (cart, price displays) pick up the new value.
      this.quantityInput.dispatchEvent(
        new CustomEvent('change', { bubbles: true, cancelable: false })
      );
    }

    this.updatingFromRadio = false;
  }

  /** User changed the PDP quantity input (typed or +/- buttons) */
  handleQtyChange() {
    if (this.updatingFromRadio) return;
    this.updatingFromQty = true;

    const qty = parseInt(this.quantityInput.value, 10) || 1;

    // Find the best matching tier: pick the highest tier whose
    // threshold the current qty meets or exceeds.
    let bestMatch = this.tierValues[0]; // default (qty 1)
    for (const tier of this.tierValues) {
      if (qty >= tier.qty) {
        bestMatch = tier;
      }
    }

    // Only update if a different radio needs selecting
    if (bestMatch && !bestMatch.radio.checked && !bestMatch.radio.disabled) {
      bestMatch.radio.checked = true;
      this.options.forEach((opt) => opt.classList.remove('is-selected'));
      bestMatch.radio.closest('.dkl-custom-picker__option').classList.add('is-selected');
    }

    this.updatingFromQty = false;
  }

  disconnectedCallback() {
    // Cleanup is handled by GC since we only listen on children + quantityInput
  }
}

if (typeof customElements !== 'undefined') {
  if (!customElements.get('dkl-custom-picker-radio-groups')) {
    customElements.define('dkl-custom-picker-radio-groups', DklCustomPickerRadioGroups);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dkl__volume-discount"] && !Shopify.designMode) return;
  try {
    class DklVolumePickerRadioGroups extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    // Remove stale quantity listeners before re-querying
    if (this.quantityInput && this._qtyHandler) {
      this.quantityInput.removeEventListener('change', this._qtyHandler);
      this.quantityInput.removeEventListener('input', this._qtyHandler);
    }

    this.options = this.querySelectorAll('.dkl-volume-picker__option');
    this.radios = this.querySelectorAll('.dkl-volume-picker__radio');
    this.tierValues = this.getTierValues();
    this.updatingFromRadio = false;
    this.updatingFromQty = false;

    const productArea = this.closest('.product-area, .product-detail, [data-product-blocks], .product-info, .product__blocks, .product-single');
    const section = productArea || this.closest('section') || this.parentElement;
    this.quantityInput = section.querySelector('quantity-wrapper [name="quantity"]')
      || section.querySelector('[name="quantity"]');

    // Radio → quantity sync
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.handleRadioChange(radio));
    });

    // Prevent clicks on disabled options
    this.options.forEach((option) => {
      option.addEventListener('click', (e) => {
        if (option.classList.contains('is-disabled')) {
          e.preventDefault();
        }
      });
    });

    // Quantity → radio sync
    if (this.quantityInput) {
      this._qtyHandler = () => this.handleQtyChange();
      this.quantityInput.addEventListener('change', this._qtyHandler);
      this.quantityInput.addEventListener('input', this._qtyHandler);
    }

    // Sync picker selection to current quantity input value
    this.handleQtyChange();
  }

  /** Build sorted array of tier qty values from the radios */
  getTierValues() {
    const values = [];
    this.radios.forEach((radio) => {
      if (radio.value === 'default') {
        values.push({ qty: 1, radio });
      } else {
        values.push({ qty: parseInt(radio.value, 10), radio });
      }
    });
    // Sort ascending by qty so we can match thresholds
    values.sort((a, b) => a.qty - b.qty);
    return values;
  }

  /** User clicked a volume tier radio */
  handleRadioChange(radio) {
    if (this.updatingFromQty) return;
    this.updatingFromRadio = true;

    // Update visual selected state
    this.options.forEach((opt) => opt.classList.remove('is-selected'));
    radio.closest('.dkl-volume-picker__option').classList.add('is-selected');

    // Sync the quantity input to match the tier
    if (this.quantityInput) {
      const qty = radio.value === 'default' ? 1 : parseInt(radio.value, 10);
      this.quantityInput.value = qty;
      // Dispatch change so Symmetry's QuantityWrapper and any other
      // listeners (cart, price displays) pick up the new value.
      this.quantityInput.dispatchEvent(
        new CustomEvent('change', { bubbles: true, cancelable: false })
      );
    }

    this.updatingFromRadio = false;
  }

  /** User changed the PDP quantity input (typed or +/- buttons) */
  handleQtyChange() {
    if (this.updatingFromRadio) return;
    this.updatingFromQty = true;

    const qty = parseInt(this.quantityInput.value, 10) || 1;

    // Find the best matching tier: pick the highest tier whose
    // threshold the current qty meets or exceeds.
    let bestMatch = this.tierValues[0]; // default (qty 1)
    for (const tier of this.tierValues) {
      if (qty >= tier.qty) {
        bestMatch = tier;
      }
    }

    // Only update if a different radio needs selecting
    if (bestMatch && !bestMatch.radio.checked && !bestMatch.radio.disabled) {
      bestMatch.radio.checked = true;
      this.options.forEach((opt) => opt.classList.remove('is-selected'));
      bestMatch.radio.closest('.dkl-volume-picker__option').classList.add('is-selected');
    }

    this.updatingFromQty = false;
  }

  disconnectedCallback() {
    // Cleanup is handled by GC since we only listen on children + quantityInput
  }
}

if (typeof customElements !== 'undefined') {
  if (!customElements.get('dkl-volume-picker-radio-groups')) {
    customElements.define('dkl-volume-picker-radio-groups', DklVolumePickerRadioGroups);
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-popup"] && !Shopify.designMode) return;
  try {
    class KlaviyoPopup extends HTMLElement {
  constructor() {
    super();

    this.liquidEligible = this.dataset.liquidEligible;
    this.campaignCodeCheck = this.dataset.campaignCodeCheck;
    this.bundleBadgeCheck = this.dataset.bundleBadgeCheck;
    this.disallowedUtmValues = this.dataset.disallowedUtmValues;
    this.delay = this.dataset.delay;
    this.klaviyoId = this.dataset.klaviyoId;
    this.limitPerSession = parseInt(this.dataset.limitPerSession);

    try {
      this.disallowedUtmValues = JSON.parse(this.disallowedUtmValues);
    } catch (err) {
      this.disallowedUtmValues = [this.disallowedUtmValues];
    }
  }

  connectedCallback() {
    if (!this.klaviyoId) return;

    // Namespaced key: Klaviyo itself uses sessionStorage `<formId>_triggered` internally, so don't collide.
    this.sessionKey = `nl_klaviyo_popup_${this.klaviyoId}_triggered`;
    this.triggeredCount = parseInt(sessionStorage.getItem(this.sessionKey)) || 0;

    if (this.checkEligibility()) {
      setTimeout(() => {
        if (this.triggeredCount < this.limitPerSession) {
          this.triggerKlaviyoPopup();
        }
      }, this.delay * 1000);
    }
  }

  disconnectedCallback() {}

  checkEligibility() {
    let isEligible = this.liquidEligible;

    if (this.campaignCodeCheck) {
      const campaignCodeEl = document.querySelector('[data-copy].dynamic-campaign-code');
      if (campaignCodeEl) isEligible = false;
    }

    if (this.bundleBadgeCheck) {
      const bundleBadgeEl = document.querySelector('.bundle-badge');
      if (bundleBadgeEl) isEligible = false;
    }

    if (this.disallowedUtmValues) {
      const utmParams = new URLSearchParams(window.location.search);
      if (utmParams.has('utm_source')) {
        const utmSource = utmParams.get('utm_source');
        for (const disallowedUtmValue of this.disallowedUtmValues) {
          if (utmSource == disallowedUtmValue) {
            isEligible = false;
          }
        }
      }
    }

    return isEligible;
  }

  async triggerKlaviyoPopup() {
    try {
      // Don't show to visitors Klaviyo already recognises as a profile.
      // Custom-trigger forms can't use Klaviyo's "Don't show to existing profiles"
      // targeting (targeting is disabled on custom trigger), so we gate it here.
      const isExistingProfile = await this.checkIsIdentified();
      if (isExistingProfile) {
        console.log('Klaviyo popup skipped — visitor is an identified profile', this.klaviyoId);
        return;
      }

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', this.klaviyoId]);
      sessionStorage.setItem(this.sessionKey, this.triggeredCount + 1);

      console.log('Klaviyo popup triggered', this.klaviyoId);
    } catch (error) {
      console.warn('Klaviyo popup failed to trigger:', error.message);
    }
  }

  // Resolves true if Klaviyo has identified the current visitor (browser tied to a
  // known profile via email click / prior identify / form submit). Defaults to false
  // (i.e. show the popup) whenever the status can't be determined.
  checkIsIdentified() {
    return new Promise((resolve) => {
      let settled = false;
      const done = (value) => {
        if (settled) return;
        settled = true;
        resolve(Boolean(value));
      };

      const kl = window.klaviyo;
      if (!kl || typeof kl.isIdentified !== 'function') {
        done(false);
        return;
      }

      // Safety net: never let an unresponsive API block the trigger.
      setTimeout(() => done(false), 1500);

      try {
        const result = kl.isIdentified((identified) => done(identified));
        if (result && typeof result.then === 'function') {
          result.then(done).catch(() => done(false));
        } else if (typeof result === 'boolean') {
          done(result);
        }
      } catch (err) {
        done(false);
      }
    });
  }
}

if (!customElements.get('klaviyo-popup')) {
  customElements.define('klaviyo-popup', KlaviyoPopup);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-quiz"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-quiz')) {
      customElements.define('size-guide-quiz', class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;

          try {
            this.data = JSON.parse(this.querySelector('.size-guide-quiz__data').textContent);
          } catch (e) {
            this.data = null;
          }
          if (!this.data) return;

          this.sizeMap = this.parseSizeMap(this.data.sizeMap);

          this.order = ['size', 'band', 'cup', 'result'].filter((n) => this.stepEl(n));
          this.current = 0;

          this.addEventListener('change', this.onChange.bind(this));
          this.addEventListener('click', this.onClick.bind(this));

          // Focusing on init would steal focus on page load for the embedded section, which renders
          // visible (a closed modal is visibility:hidden, so the same call is inert there).
          this.show(0, false);
        }

        stepEl(name) {
          return this.querySelector('[data-step="' + name + '"]');
        }

        checked(field) {
          const el = this.querySelector('[data-quiz-field="' + field + '"]:checked');
          return el ? el.value : null;
        }

        stepReady(step) {
          if (step.dataset.step === 'size') {
            // Require a pick in every axis that's actually rendered — both for a two-axis bra guide,
            // just the one for a single-axis guide. An axis with no field is vacuously satisfied.
            return ['band', 'cup'].every((field) =>
              !step.querySelector('[data-quiz-field="' + field + '"]')
              || !!step.querySelector('[data-quiz-field="' + field + '"]:checked'));
          }
          return !!step.querySelector('input[type="radio"]:checked');
        }

        /**
         * Disables a hidden step's controls so it drops out of the modal's focus trap.
         *
         * trapFocus (main.js) collects focusables with querySelectorAll, which matches inside
         * [hidden] subtrees, so its lastEl was the restart button on the hidden result step —
         * unreachable, so Tab escaped the modal. Its selector does skip disabled buttons/inputs and
         * anchors without href, which is why toggling those works. Radios keep :checked and .value
         * while disabled, so the maths still reads earlier steps.
         */
        setStepEnabled(step, enabled) {
          step.querySelectorAll('button, input').forEach((el) => { el.disabled = !enabled; });
          step.querySelectorAll('a').forEach((a) => {
            if (enabled) {
              // computeResult() runs before show(), so a fresh href is already set and must win.
              if (a.dataset.hrefStash) {
                if (!a.hasAttribute('href')) a.setAttribute('href', a.dataset.hrefStash);
                delete a.dataset.hrefStash;
              }
            } else if (a.hasAttribute('href')) {
              a.dataset.hrefStash = a.getAttribute('href');
              a.removeAttribute('href');
            }
          });
          if (enabled) {
            const next = step.querySelector('[data-quiz-next]');
            if (next) next.disabled = !this.stepReady(step);
          }
        }

        /**
         * trapFocus snapshots its focusable list when the modal opens and never revisits it — fine
         * for a static modal, stale for a wizard. Re-arm on anything that changes what is focusable.
         * @param {Element} [focusEl] - Element to focus; defaults to keeping focus where it is.
         */
        rearmTrap(focusEl) {
          const modal = this.closest('modal-dialog');
          if (!modal || !modal.hasAttribute('open') || typeof trapFocus !== 'function') return false;
          trapFocus(modal, focusEl || document.activeElement);
          return true;
        }

        onChange(e) {
          if (!e.target.matches('input[type="radio"]')) return;
          const step = e.target.closest('[data-step]');
          const next = step.querySelector('[data-quiz-next]');
          if (!next) return;
          const was = next.disabled;
          next.disabled = !this.stepReady(step);
          if (was !== next.disabled) this.rearmTrap(document.activeElement);
        }

        onClick(e) {
          const add = e.target.closest('[data-quiz-add]');
          if (add) { this.addToCart(add); return; }
          if (e.target.closest('[data-quiz-next]')) this.go(1);
          else if (e.target.closest('[data-quiz-back]')) this.go(-1);
          else if (e.target.closest('[data-quiz-restart]')) this.restart();
        }

        go(dir) {
          const target = this.current + dir;
          if (target < 0 || target >= this.order.length) return;
          this.current = target;
          if (this.order[this.current] === 'result') this.computeResult();
          this.show(this.current);
        }

        show(i, moveFocus = true) {
          this.order.forEach((name, idx) => {
            const el = this.stepEl(name);
            if (!el) return;
            el.hidden = idx !== i;
            this.setStepEnabled(el, idx === i);
          });
          this.setAttribute('data-active-step', this.order[i]);

          const isResult = this.order[i] === 'result';

          // Denominator counts questions, not steps — the result is an outcome, and both the counter
          // and the bar retire there. So the last question reads 3/3 with the bar full, rather than
          // 3/4 with the bar stuck at 67% and only completing on a screen nobody sees.
          const questions = this.order.length - 1;
          // A single-question flow (conversion mode) has nothing to count, so the counter and bar
          // stay hidden rather than showing a permanent "1/1".
          const single = questions <= 1;
          const progress = this.querySelector('[data-quiz-progress]');
          if (progress) {
            progress.hidden = isResult || single;
            if (!progress.hidden) progress.textContent = (i + 1) + '/' + questions;
          }

          const bar = this.querySelector('[data-quiz-bar]');
          if (bar) bar.hidden = isResult || single;
          this.style.setProperty('--quiz-progress', (Math.min(i + 1, questions) / questions).toFixed(3));

          // Announced here rather than in computeResult, which runs while the step is still hidden.
          const announce = this.querySelector('[data-quiz-announce]');
          if (announce) {
            if (!isResult) {
              announce.textContent = '';
            } else {
              // When no size is on screen the size is not the news, the copy is.
              const badge = this.querySelector('[data-quiz-badge]');
              const src = badge && badge.hidden
                ? this.querySelector('[data-quiz-result="' + this.state + '"] .size-guide-quiz__result-title')
                : this.querySelector('[data-quiz-size]');
              announce.textContent = src ? src.textContent : '';
            }
          }

          if (!moveFocus) return;

          const el = this.stepEl(this.order[i]);
          if (!el) return;

          // The container, not a heading: the result step's only h3 may itself be hidden, and
          // focusing a display:none element silently drops focus to <body>.
          el.setAttribute('tabindex', '-1');
          if (!this.rearmTrap(el)) el.focus({ preventScroll: true });
        }

        clamp(n, max) {
          return Math.max(0, Math.min(max, n));
        }

        parseSizeMap(raw) {
          const map = {};
          if (!raw) return map;

          raw.split(/\r?\n/).forEach((line) => {
            const i = line.indexOf(':');
            if (i < 0) return;
            const out = line.slice(0, i).trim();
            if (!out) return;
            line.slice(i + 1).split(',').forEach((k) => {
              const key = k.trim().toUpperCase();
              if (key) map[key] = out;
            });
          });

          return map;
        }

        computeConversion() {
          const bandIndex = parseInt(this.checked('band'), 10);
          const cupIndex = parseInt(this.checked('cup'), 10);
          const data = this.data;

          const sizeEl = this.querySelector('[data-quiz-size]');
          const addBtn = this.querySelector('[data-quiz-add]');

          // Key the lookup on whichever axes the guide uses: both (bra "75B") or a single value (a
          // one-input conversion guide, e.g. "S"). Built from the SYSTEM arrays so it's locale-
          // invariant; a present axis whose system value is missing yields no key, so no match.
          const keyOf = (bi, ci) => {
            const parts = [];
            if (Number.isInteger(bi)) {
              const bandSystem = data.bandsSystem[bi];
              if (bandSystem == null) return null;
              parts.push(bandSystem);
            }
            if (Number.isInteger(ci)) {
              const cupSystem = data.cupsSystem[ci];
              if (cupSystem == null) return null;
              parts.push(cupSystem);
            }
            return parts.length ? parts.join('').toUpperCase() : null;
          };

          const origKey = keyOf(bandIndex, cupIndex);
          const original = origKey ? (this.sizeMap[origKey] || null) : null;
          let mapped = original;
          let adjusted = false;

          // A per-product size_indicator (PDP) nudges the recommendation one step up/down — the same
          // +/- rule as the bra cup shift, applied to the size axis of a single-axis conversion guide
          // (band only, no cup), which is where a "runs big/small in size" product lands. A shift past
          // the end of the ladder is out-of-range, as in fit mode.
          const indDelta = (data.sizeIndicator && data.sizeIndicator.cupDelta) || 0;
          if (indDelta !== 0 && Number.isInteger(bandIndex) && !Number.isInteger(cupIndex)) {
            const maxBand = Math.min(data.bandsUi.length, data.bandsSystem.length) - 1;
            const wantBand = bandIndex + indDelta;
            const clampedBand = this.clamp(wantBand, maxBand);
            if (wantBand !== clampedBand) {
              mapped = null;
            } else {
              const adjMapped = this.sizeMap[keyOf(clampedBand, cupIndex)] || null;
              if (adjMapped && adjMapped !== original) {
                mapped = adjMapped;
                adjusted = true;
              }
            }
          }

          if (sizeEl) sizeEl.textContent = mapped || '';

          const variant = mapped ? this.findVariant(mapped, 'display') : null;

          // findVariant returns the variant whether it is in stock or sold out, and null when the
          // product has no such size at all — which is how "sold out" (unavailable) is told apart
          // from "this product doesn't come in that size" (out-of-range). Unmapped input, having no
          // size to look up, is out-of-range too.
          let state;
          if (!mapped || !variant) state = 'out-of-range';
          else if (!variant.available) state = 'unavailable';
          else state = adjusted ? 'adjusted' : 'available';

          // A conversion output ("Small") is not a size handle, so there is never a collection link.
          this.querySelectorAll('[data-quiz-collection-link]').forEach((a) => {
            a.removeAttribute('href');
            a.hidden = true;
          });

          // No link to gate the body copy on, unlike fit mode — so it always shows.
          this.querySelectorAll(
            '[data-quiz-result="available"] .size-guide-quiz__text,'
            + '[data-quiz-result="unavailable"] .size-guide-quiz__text'
          ).forEach((el) => { el.hidden = false; });

          this.variantId = (state === 'available' || state === 'adjusted') ? variant.id : null;
          if (addBtn) addBtn.hidden = !this.variantId;

          // Badge is hidden for out-of-range in both its forms — no size mapped, or a mapped size the
          // product doesn't carry. Showing "your size is XS+" when the product has no XS+ is exactly
          // what the merchant doesn't want, so out-of-range shows the copy alone.
          const badge = this.querySelector('[data-quiz-badge]');
          if (badge) badge.hidden = state === 'out-of-range';

          // Adjusted title: the guide's up/down text with the shopper's own output and the shifted one
          // filled in — "Din størrelse er {original} … anbefaler vi {adjusted}". Same fields and tokens
          // as the fit-mode cup shift, reused here for the size shift.
          if (state === 'adjusted') {
            const el = this.querySelector('[data-quiz-adjusted-text]');
            if (el) {
              const tpl = indDelta < 0 ? data.cupAdjustDownText : data.cupAdjustUpText;
              el.textContent = (tpl || '')
                .replace(/\{original\}/gi, original || '')
                .replace(/\{adjusted\}/gi, mapped || '');
            }
          }

          this.querySelectorAll('[data-quiz-result]').forEach((el) => {
            el.hidden = el.dataset.quizResult !== state;
          });
          this.state = state;
        }

        computeResult() {
          if (this.data.mode === 'conversion') {
            this.computeConversion();
            return;
          }

          // The pickers yield an INDEX, not a label — the index is locale-invariant.
          const bandIndex = parseInt(this.checked('band'), 10);
          const cupIndex = parseInt(this.checked('cup'), 10);
          const bandFeel = this.checked('bandFeel');
          const cupFeel = this.checked('cupFeel');

          const sizeEl = this.querySelector('[data-quiz-size]');
          const addBtn = this.querySelector('[data-quiz-add]');

          const data = this.data;
          let uiSize = null;
          let systemSize = null;
          let systemPair = null;
          let outOfRange = false;
          let adjusted = false;
          let originalUi = null;

          if (Number.isInteger(bandIndex) && Number.isInteger(cupIndex)) {
            const outcome = data.outcomes.find((o) => o.band === bandFeel && o.cup === cupFeel);
            const deltaBand = outcome ? outcome.deltaBand : 0;
            const deltaCup = outcome ? outcome.deltaCup : 0;

            // A per-product size_indicator (fit, PDP) nudges the recommendation one cup up/down. The
            // adjusted size then drives availability, add-to-cart and out-of-range like any other size.
            const indCup = (data.sizeIndicator && data.sizeIndicator.cupDelta) || 0;

            // Bounded by BOTH arrays, so a mis-parallel system list cannot index out of range and
            // produce a handle like "bh-storrelse-undefinedd".
            const maxBand = Math.min(data.bandsUi.length, data.bandsSystem.length) - 1;
            const maxCup = Math.min(data.cupsUi.length, data.cupsSystem.length) - 1;

            // The base (feel-adjusted) cup, before the indicator — gives the "Din BH størrelse er X".
            const baseCup = this.clamp(cupIndex + deltaCup, maxCup);

            const wantBand = bandIndex + deltaBand;
            const wantCup = cupIndex + deltaCup + indCup;
            const clampedBand = this.clamp(wantBand, maxBand);
            const clampedCup = this.clamp(wantCup, maxCup);

            // Test the clamp, not `size === input`: "everything fits" legitimately returns the same
            // size and is the right answer, whereas 90G + "digs in, cups overflow" returns 90G only
            // because we ran out of sizes — and must never be recommended back.
            outOfRange = wantBand !== clampedBand || wantCup !== clampedCup;

            // Active only when the indicator actually moved the cup; a delta that clamps to the same
            // cup (already at the ladder end) falls back to the normal result.
            adjusted = indCup !== 0 && clampedCup !== baseCup;

            const bandUi = data.bandsUi[clampedBand];
            const cupUi = data.cupsUi[clampedCup];
            const bandSystem = data.bandsSystem[clampedBand];
            const cupSystem = data.cupsSystem[clampedCup];

            if (bandUi != null && cupUi != null && bandSystem != null && cupSystem != null) {
              uiSize = bandUi + cupUi;              // shown to the customer (fr: "85D")
              systemSize = bandSystem + cupSystem;  // builds the handle     (fr: "70D")
              systemPair = (bandSystem + '-' + cupSystem).toLowerCase();
            }

            // Band isn't adjusted, so the "original" size is the same band with the pre-indicator cup.
            if (adjusted) {
              const baseCupUi = data.cupsUi[baseCup];
              if (bandUi != null && baseCupUi != null) originalUi = bandUi + baseCupUi;
            }
          }

          if (sizeEl) sizeEl.textContent = uiSize || '';

          // Sizes the merchant never built a collection for. The handle is written blind, so without
          // this list the link is a confident 404.
          const excluded = (data.noCollectionCombos || [])
            .map((s) => String(s).trim().toLowerCase())
            .indexOf(systemPair) > -1;

          const colUrl = systemSize && !excluded ? this.collectionUrl(systemSize) : null;
          const isPdp = data.context === 'pdp';
          const variant = this.findVariant(systemSize);

          // out-of-range outranks a live variant: a clamped size is the end of the ladder, not a
          // recommendation, so it must never be sold back to the customer.
          const addable = isPdp && !outOfRange && variant && variant.available;

          // Having something to add beats every "we don't have it" branch. "no-collection" means the
          // size isn't part of the range at all, so it needs there to be no real variant — a carried
          // size that's merely sold out stays 'unavailable' even with no per-size collection (AA cups
          // are all on the exclusion list yet are still real, sometimes-stocked variants).
          let state;
          if (addable && adjusted) state = 'adjusted';
          else if (addable) state = 'available';
          else if (excluded && !variant) state = 'no-collection';
          else if (outOfRange) state = 'out-of-range';
          else if (isPdp) state = 'unavailable';
          else state = colUrl ? 'available' : 'unavailable';

          // Suppressed out of range ("all bras in 90G" contradicts "we found no better size") and
          // whenever the size_indicator adjusted the result — the point there is the one recommended
          // model size, not a browse-all link.
          const showLink = !!colUrl && state !== 'out-of-range' && !adjusted;
          this.querySelectorAll('[data-quiz-collection-link]').forEach((a) => {
            if (!showLink) {
              a.removeAttribute('href');
              a.hidden = true;
              return;
            }
            a.href = colUrl;
            a.hidden = false;

            const tpl = a.dataset.labelTemplate || '';
            a.textContent = tpl.indexOf('{size}') > -1
              ? tpl.replace('{size}', uiSize)
              : (tpl + ' ' + uiSize).trim();
          });

          // The available text is a lead-in to the collection link, so it hides when there's no link.
          // The unavailable text is a lead-in too on a guide that uses collections (hide it when there's
          // no link, e.g. an excluded size, so it doesn't promise a browse that 404s), but on a guide
          // with no collection prefix it's a standalone "sold out" message that must always show.
          const hasCollections = !!data.collectionPrefix;
          this.querySelectorAll('[data-quiz-result="available"] .size-guide-quiz__text')
            .forEach((el) => { el.hidden = !showLink; });
          this.querySelectorAll('[data-quiz-result="unavailable"] .size-guide-quiz__text')
            .forEach((el) => { el.hidden = hasCollections && !showLink; });

          this.variantId = (state === 'available' || state === 'adjusted') && isPdp && variant ? variant.id : null;
          if (addBtn) addBtn.hidden = !this.variantId;

          // Demoted to secondary only while add-to-cart is present to be the primary action;
          // on its own the collection link IS the primary action.
          const addVisible = !!this.variantId;
          this.querySelectorAll('[data-quiz-collection-link]').forEach((a) => {
            a.classList.toggle('btn--secondary', addVisible);
          });

          // Keyed off the clamp, not the state: a clamped size is the end of the ladder rather than
          // an answer, and showing it as one is wrong on whichever state it lands in.
          const badge = this.querySelector('[data-quiz-badge]');
          if (badge) badge.hidden = outOfRange;

          // The adjusted title comes from the product's size_indicator, with the base and recommended
          // sizes filled in — "Din BH størrelse er {original} … anbefaler vi {adjusted}".
          if (state === 'adjusted') {
            const el = this.querySelector('[data-quiz-adjusted-text]');
            if (el) {
              const delta = (data.sizeIndicator && data.sizeIndicator.cupDelta) || 0;
              const tpl = delta < 0 ? data.cupAdjustDownText : data.cupAdjustUpText;
              el.textContent = String(tpl || '')
                .replace(/\{original\}/gi, originalUi || '')
                .replace(/\{adjusted\}/gi, uiSize || '');
            }
          }

          this.querySelectorAll('[data-quiz-result]').forEach((el) => {
            el.hidden = el.dataset.quizResult !== state;
          });
          this.state = state;
        }

        /**
         * Mirrors ProductForm.handleSubmit (main.js) so the drawer/notification behave as usual,
         * without being a <product-form> — variant-picker.js rewrites [name="id"] on every
         * .js-product-form in the section and would swap our variant for the one selected on the PDP.
         */
        async addToCart(btn) {
          if (!this.variantId || btn.getAttribute('aria-disabled') === 'true') return;
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-loading');
          this.setError('');

          const sectionsToUpdate = ['page-header', 'cart-drawer']
            .map((sel) => document.querySelector(sel))
            .filter((el) => el);

          // Only the request may fail into the error branch; everything after a successful add is UI
          // work, and sharing this try would report "add failed" for an item that IS in the cart.
          let data;
          try {
            // Single-item shape, not { items: [...] }: only this makes /cart/add.js return the line
            // item itself, which is what ProductForm passes as detail.data and what the GTM listener
            // in gtm-datalayer.liquid reads (detail.data.image.src). The batch response has no such
            // field, so it throws there and the add goes untracked.
            const res = await fetch(theme.routes.cartAdd, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              body: JSON.stringify({
                id: this.variantId,
                quantity: 1,
                sections: sectionsToUpdate.map((el) => el.dataset.sectionId).join(','),
                sections_url: window.location.pathname
              })
            });
            data = await res.json();
            if (!res.ok) throw new Error(data.description || data.message || res.status);
          } catch (e) {
            // Never e.message — on a 429 or an HTML error page that is a raw parse error.
            const msg = (data && data.description) || this.dataset.addError;
            console.error('[size-guide-quiz] add to cart failed', e);
            this.setError(msg);
            this.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: msg } }));
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('is-loading');
            return;
          }

          try {
            if (data.sections) {
              sectionsToUpdate.forEach((el) => el.updateFromCartChange(data.sections[el.dataset.sectionId]));
            }

            // detail.data.* is a contract — GTM and apps read it. Match ProductForm exactly.
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: { variantId: data.variant_id, quantity: data.quantity, data }
            }));

            // Close first, or the drawer/notification stacks behind the modal.
            const closeBtn = this.closest('modal-dialog')?.querySelector('.js-close-modal');
            if (closeBtn) closeBtn.click();

            // Every branch, or stores set to 'notification' add to the cart with no feedback at all.
            const after = theme.settings.afterAddToCart;
            if (document.querySelector('.template-cart')) {
              const cartForm = document.querySelector('cart-form');
              if (cartForm && cartForm.enableAjaxUpdate) cartForm.refresh();
            } else if (after === 'page') {
              window.location.href = theme.routes.cart;
            } else if (after === 'drawer') {
              document.querySelector('.js-cart-drawer')?.open();
            } else if (after === 'notification') {
              const tpl = document.getElementById('AddedNotification');
              if (tpl) {
                const note = tpl.content.firstElementChild.cloneNode(true);
                note.dataset.productTitle = data.product_title;
                (document.querySelector('.pageheader--sticky') || document.body).appendChild(note);
              }
            }

            btn.classList.add('is-success');
          } catch (e) {
            // The item is already in the cart — never surface this to the customer as a failure.
            console.error('[size-guide-quiz] post-add UI step failed', e);
          } finally {
            btn.removeAttribute('aria-disabled');
            // Long enough for the success tick to play.
            setTimeout(() => {
              btn.classList.remove('is-loading');
              btn.classList.remove('is-success');
            }, 2000);
          }
        }

        setError(message) {
          const el = this.querySelector('[data-quiz-error]');
          if (!el) return;
          el.textContent = message || '';
          el.hidden = !message;
        }

        /**
         * Finds the variant for the suggested size, holding every other option (colour) at whatever
         * the customer has selected. The main form's [name="id"] is the theme's source of truth —
         * variant-picker keeps it in sync.
         *
         * Two match modes, because fit and conversion hand the size in differently:
         * - 'canonical' (fit): sizeValue is the canonical EU size, matched against the variant's
         *   EU-tagged token. "FR 90D (EU 75D)" / "EU 75D (FR 90D)" both yield "75D"; untranslated
         *   markets render it bare. Matching the EU token (not a bare number) avoids the ambiguity
         *   FR = EU+15 creates — "75D" is one size's EU label and another's FR label.
         * - 'display' (conversion): sizeValue is the merchant's per-locale output label (fr "85C/D"),
         *   matched against the variant's primary shown size — the part before the "(EU …)" tag, minus
         *   its FR/EU prefix. Each variant's shown size is unique so this is unambiguous, and unlike
         *   the EU-token regex it keeps merged sizes ("85C/D") whole instead of stopping at the slash.
         *
         * @param {string} sizeValue - canonical EU size (fit) or locale output label (conversion).
         * @param {'canonical'|'display'} [matchMode] - defaults to 'canonical'.
         */
        findVariant(sizeValue, matchMode) {
          const d = this.data;
          if (!d.variants || !d.variants.length || d.sizeIdx == null || !sizeValue) return null;

          const idx = d.sizeIdx;
          const canonicalOf = (optValue) => {
            const s = String(optValue == null ? '' : optValue);
            const m = s.match(/\bEU\s*([0-9]{2,3}[A-Za-z]+(?:\/[A-Za-z]+)?)\b/i);
            return (m ? m[1] : s).trim().toUpperCase();
          };
          const localeLabelOf = (optValue) => {
            let s = String(optValue == null ? '' : optValue);
            const paren = s.indexOf('(');
            if (paren > -1) s = s.slice(0, paren);        // drop the "(EU …)" / "(FR …)" tag
            return s.replace(/^\s*(FR|EU)\s+/i, '').trim().toUpperCase();
          };
          const normalize = matchMode === 'display' ? localeLabelOf : canonicalOf;
          // Reduce the wanted size the same way as each variant option, so a merchant's full output
          // label ("FR 38 (EU 36)") matches the variant's stripped shown size ("38"). A bare label and
          // the canonical fit token reduce to themselves, so existing outputs and fit mode are unchanged.
          const want = normalize(sizeValue);
          const matchesSize = (v) => normalize(v.options[idx]) === want;

          // Scoped: unscoped this takes the document's first .js-product-form, which a Featured
          // product section above the PDP would win — yielding another product's variant id.
          const scope = this.closest('product-form') || document;
          const input = scope.querySelector('.js-product-form:not(.js-upsell-form) [name="id"]');
          const current = input && input.value
            ? d.variants.find((v) => String(v.id) === String(input.value))
            : null;

          if (current) {
            const sameOtherOptions = (v) => v.options.every((val, i) => i === idx || val === current.options[i]);
            const exact = d.variants.find((v) => matchesSize(v) && sameOtherOptions(v));
            if (exact) return exact;
          }

          // No current selection (or no variant in that colour) — fall back to size alone.
          return d.variants.find(matchesSize) || null;
        }

        /**
         * prefix + systemSize, lowercased -> "bh-storrelse-70d". Built blind, never looked up: the
         * merchant owns the handles, and addressing by canonical size lets Shopify resolve the
         * translated handle itself on other markets (fr: soutien-gorge-taille-100d).
         */
        collectionUrl(systemSize) {
          // No prefix means the merchant hasn't built per-size collections, so there is no link at
          // all — without this guard an empty prefix would point at "/collections/<size>", a
          // confident 404, and the link button would still render.
          const prefix = this.data.collectionPrefix;
          if (!systemSize || !prefix) return null;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const handle = (prefix + systemSize).toLowerCase();
          return root + 'collections/' + handle;
        }

        restart() {
          this.querySelectorAll('input[type="radio"]').forEach((r) => { r.checked = false; });
          this.querySelectorAll('[data-quiz-next]').forEach((b) => { b.disabled = true; });
          const addBtn = this.querySelector('[data-quiz-add]');
          if (addBtn) addBtn.hidden = true;
          this.setError('');
          this.variantId = null;
          this.current = 0;
          this.show(0);
        }
      });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sleeknote-popup"] && !Shopify.designMode) return;
  try {
    class SleeknotePopup extends HTMLElement {
  constructor() {
    super();
    
    this.liquidEligible = this.dataset.liquidEligible;
    this.campaignCodeCheck = this.dataset.campaignCodeCheck;
    this.bundleBadgeCheck = this.dataset.bundleBadgeCheck;
    this.disallowedUtmValues = this.dataset.disallowedUtmValues;
    this.delay = this.dataset.delay;
    this.sleeknoteId = this.dataset.sleeknoteId;
    this.limitPerSession = parseInt(this.dataset.limitPerSession);
    
    try {
      this.disallowedUtmValues = JSON.parse(this.disallowedUtmValues);
    } catch (err) {
      this.disallowedUtmValues = [this.disallowedUtmValues];
    }    
  }
  
  connectedCallback() {    
    this.triggeredCount = parseInt(sessionStorage.getItem(`${this.sleeknoteId}_triggered`)) || 0;
        
    if (this.checkEligibility()) {      
      setTimeout(() => {
        if (this.triggeredCount < this.limitPerSession) {
          this.triggerSleekNotePopup();
        }
      }, this.delay * 1000);
    }
  }
  
  disconnectedCallback() {}
  
  checkEligibility() {
    let isEligible = this.liquidEligible;

    if (this.campaignCodeCheck) {
      const campaignCodeEl = document.querySelector('[data-copy].dynamic-campaign-code');
      if (campaignCodeEl) isEligible = false;
    }
    
    if (this.bundleBadgeCheck) {
      const bundleBadgeEl = document.querySelector('.bundle-badge');
      if (bundleBadgeEl) isEligible = false;
    }
    
    if (this.disallowedUtmValues) {
      const utmParams = new URLSearchParams(window.location.search);
      if (utmParams.has('utm_source')) {
        const utmSource = utmParams.get('utm_source');
        for (const disallowedUtmValue of this.disallowedUtmValues) {
          if (utmSource == disallowedUtmValue) { 
            isEligible = false;
          }
        }
      }
    }
    
    return isEligible;
  }
  
  loadSleekNoteScript() {
    return new Promise((resolve, reject) => {
      if (window.SleekNote) {
        resolve(window.SleekNote);
      }
      
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.src = '//sleeknotecustomerscripts.sleeknote.com/31.js';
      
      script.onload = () => {
        if (window.SleekNote?.triggerOnClick) {
          resolve(window.SleekNote);
        } else {
          reject(new Error('SleekNote failed to initialize'));
        }
      };
      
      script.onerror = () => {
        reject(new Error('Failed to load SleekNote script'));
      };
      
      const currentScript = document.getElementById('sleeknoteScript');
      currentScript.parentNode.insertBefore(script, currentScript);
    });
  }
  
  async triggerSleekNotePopup() {
    try {
      const sleekNote = await this.loadSleekNoteScript();
      sleekNote.triggerOnClick(this.sleeknoteId);
      sessionStorage.setItem(`${this.sleeknoteId}_triggered`, this.triggeredCount + 1);
      
      console.log('SleekNote popup triggered', this.sleeknoteId);
    } catch (error) {
      console.warn('SleekNote popup failed to load:', error.message);
    }
  };
}

customElements.define('sleeknote-popup', SleeknotePopup);
  } catch(e) { console.error(e); }
})();

})();
